(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  const directSummary = (details) => Array.from(details.children).find((el) => el.tagName === 'SUMMARY');

  const closeNested = (menu, except = null) => {
    Array.from(menu.children).forEach((item) => {
      const details = Array.from(item.children).find((el) => el.tagName === 'DETAILS');
      if (!details || details === except) return;
      details.removeAttribute('open');
      directSummary(details)?.setAttribute('aria-expanded', 'false');
    });
  };

  const openNested = (details) => {
    if (!desktop.matches || !details) return;
    const item = details.parentElement;
    const menu = item?.parentElement;
    if (!menu?.classList.contains('list-menu--disclosure')) return;

    closeNested(menu, details);
    details.setAttribute('open', '');
    directSummary(details)?.setAttribute('aria-expanded', 'true');
  };

  const setup = () => {
    document.querySelectorAll('.header__inline-menu .header__submenu.list-menu--disclosure').forEach((menu) => {
      if (menu.dataset.hmCascadeReady === 'true') return;
      menu.dataset.hmCascadeReady = 'true';

      Array.from(menu.children).forEach((item) => {
        const details = Array.from(item.children).find((el) => el.tagName === 'DETAILS');

        if (details) {
          const summary = directSummary(details);
          item.addEventListener('mouseenter', () => openNested(details));
          summary?.addEventListener('focus', () => openNested(details));
          summary?.addEventListener('click', (event) => {
            if (!desktop.matches) return;
            event.preventDefault();
            openNested(details);
          });
        } else {
          item.addEventListener('mouseenter', () => {
            if (desktop.matches) closeNested(menu);
          });
        }
      });

      menu.addEventListener('mouseleave', () => {
        if (desktop.matches) closeNested(menu);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();
